import { useEffect } from 'react';

/**
 * 锁定页面滚动的 Hook
 * 用于防止移动端滚动穿透问题
 */
export function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    // 获取当前滚动位置
    const scrollY = window.scrollY;
    
    // 保存原始样式
    const originalStyle = window.getComputedStyle(document.body);
    const originalOverflow = originalStyle.overflow;
    const originalPosition = originalStyle.position;
    const originalTop = originalStyle.top;
    const originalWidth = originalStyle.width;

    // 应用锁定样式
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';

    // 清理函数
    return () => {
      // 恢复原始样式
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.top = originalTop;
      document.body.style.width = originalWidth;
      
      // 恢复滚动位置
      window.scrollTo(0, scrollY);
    };
  }, [isLocked]);
}

/**
 * 移动端滚动穿透防护的 Hook
 * 专门用于处理触摸事件
 */
export function useTouchScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    const preventDefault = (e: TouchEvent) => {
      // 允许在可滚动元素内的触摸
      const target = e.target as Element;
      const scrollableParent = target.closest('[data-scrollable="true"]');
      
      if (!scrollableParent) {
        e.preventDefault();
      }
    };

    // 添加触摸事件监听器
    document.addEventListener('touchmove', preventDefault, { passive: false });
    document.addEventListener('touchstart', preventDefault, { passive: false });

    return () => {
      document.removeEventListener('touchmove', preventDefault);
      document.removeEventListener('touchstart', preventDefault);
    };
  }, [isLocked]);
}
